var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.004,
    height: 40.999,
    viewBox: "0 0 41.004 40.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_50",
    "data-name": "Subtraction 50",
    d: "M20624.5-2529a20.373,20.373,0,0,1-14.5-6A20.353,20.353,0,0,1,20604-2549.5,20.362,20.362,0,0,1,20610-2564a20.368,20.368,0,0,1,14.5-6.006A20.368,20.368,0,0,1,20639-2564a20.369,20.369,0,0,1,6.006,14.5,20.361,20.361,0,0,1-6.006,14.494A20.373,20.373,0,0,1,20624.5-2529Zm-9.15-23.861a2.75,2.75,0,0,0-1.979.835,2.909,2.909,0,0,0,0,4.047l6.424,6.565a2.725,2.725,0,0,0,1.963.839h.027a2.757,2.757,0,0,0,1.979-.839l11.871-12.129a2.91,2.91,0,0,0,0-4.041,2.756,2.756,0,0,0-1.979-.835,2.764,2.764,0,0,0-1.98.835l-9.9,10.114-4.451-4.554A2.756,2.756,0,0,0,20615.35-2552.863Z",
    transform: "translate(-20603.998 2570.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.4ec61ee3aa3dd6061ecbbf67e65a7fba.svg";
export { ForwardRef as ReactComponent };